import React from 'react';
import './Analytics.css';

function Analytics() {
  return (
    <section className="container py-4 py-md-5 my-md-3 my-lg-4 my-xl-5">
      <div className="row g-4">

        {/* Left Column - Title, Subtitle, Image */}
        <div className="col-12 col-lg-5">
          <h2 className="h1 text-start">Analytics & Project Intelligence</h2>
          <p className="fs-lg">
            The insights you need to run better projects, built into every workflow.
          </p>
          <div className="position-relative rounded-3 mt-4">
            <img src="/assets/home_page/v3/images/analytics.png" className="d-block rounded-3 w-100 img-fluid" alt="Stats screen" />
          </div>
        </div>

        {/* Right Column - 2x2 Card Grid */}
        <div className="col-12 col-lg-7">
          <div className="row g-3 h-100">

            {/* Card 1 - Operational & Production Intelligence */}
            <div className="col-6">
              <div className="card card-v3 border-0 shadow h-100 text-start p-2 p-lg-3">
                <div className="card-body card-body-v3 p-2">
                  <div className="analytics-icon-wrapper d-table rounded flex-shrink-0 p-2 mb-2 mb-md-3">
                    <img src="/assets/home_page/v3/icons/quality_monitoring.png" className="analytics-icon d-block m-1 img-fluid" alt="Quality Monitoring Icon" />
                  </div>
                  <h3 className="h5 mb-2">Operational & Production Intelligence</h3>
                  <p className="fs-sm mb-0">Track inspections, welds, milestones, technician performance, and production rates across every project in real time.</p>
                </div>
              </div>
            </div>

            {/* Card 2 - Compliance & Reporting Analytics */}
            <div className="col-6">
              <div className="card card-v3 border-0 shadow h-100 text-start p-2 p-lg-3">
                <div className="card-body card-body-v3 p-2">
                  <div className="analytics-icon-wrapper d-table rounded flex-shrink-0 p-2 mb-2 mb-md-3">
                    <img src="/assets/home_page/v3/icons/production_analytics.png" className="analytics-icon d-block m-1 img-fluid" alt="Production Analytics Icon" />
                  </div>
                  <h3 className="h5 mb-2">Compliance & Reporting Analytics</h3>
                  <p className="fs-sm mb-0">Monitor audit readiness, outstanding items, missing signatures, uncorrected deviations, and reporting accuracy at any point in the project lifecycle.</p>
                </div>
              </div>
            </div>

            {/* Card 3 - Financial Intelligence */}
            <div className="col-6">
              <div className="card card-v3 border-0 shadow h-100 text-start p-2 p-lg-3">
                <div className="card-body card-body-v3 p-2">
                  <div className="analytics-icon-wrapper d-table rounded flex-shrink-0 p-2 mb-2 mb-md-3">
                    <img src="/assets/home_page/v3/icons/cost_intelligence.png" className="analytics-icon d-block m-1 img-fluid" alt="Cost Intelligence Icon" />
                  </div>
                  <h3 className="h5 mb-2">Financial Intelligence</h3>
                  <p className="fs-sm mb-0">Tie productivity and quality data directly to cost impact. Track expenditure, billing, and budget variance as projects progress.</p>
                </div>
              </div>
            </div>

            {/* Card 4 - Welding Analytics */}
            <div className="col-6">
              <div className="card card-v3 border-0 shadow h-100 text-start p-2 p-lg-3">
                <div className="card-body card-body-v3 p-2">
                  <div className="analytics-icon-wrapper d-table rounded flex-shrink-0 p-2 mb-2 mb-md-3">
                    <img src="/assets/home_page/v3/icons/operational_context.png" className="analytics-icon d-block m-1 img-fluid" alt="Operational Context Icon" />
                  </div>
                  <h3 className="h5 mb-2">Welding Analytics</h3>
                  <p className="fs-sm mb-0">Monitor weld quality outcomes, defect and repair rates, and performance trends by welder, procedure, or material.</p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}

export default Analytics;

